import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { Button } from "@/components/ui/button";

export default function PendingProfilesList() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    async function fetchPending() {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, first_name, last_name, email, phone, created_at")
        .eq("approved", false)
        .order("created_at", { ascending: true });

      if (!error) setProfiles(data);
      setLoading(false);
    }
    fetchPending();
  }, [refresh]);

  const handleApprove = async (profileId) => {
    const user = await supabase.auth.getUser();
    const adminId = user.data.user?.id;

    const { error: updateError } = await supabase
      .from("profiles")
      .update({ approved: true })
      .eq("id", profileId);

    if (!updateError) {
      await supabase.from("validation_logs").insert([
        { profile_id: profileId, validated_by: adminId, comment: "Validé manuellement" }
      ]);
      setRefresh(!refresh);
    }
  };

  if (loading) return <p>Chargement des profils en attente...</p>;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold mb-4">🛂 Profils à approuver</h2>
      {profiles.length === 0 && <p className="text-gray-600">Aucun nouveau profil en attente.</p>}

      {profiles.map((p) => (
        <div key={p.id} className="border p-4 rounded shadow bg-white">
          <p className="font-semibold">{p.first_name} {p.last_name}</p>
          <p className="text-sm text-gray-600">📧 {p.email} | 📞 {p.phone}</p>
          <p className="text-xs text-gray-500">Créé le : {new Date(p.created_at).toLocaleDateString()}</p>
          <Button className="mt-2" onClick={() => handleApprove(p.id)}>
            ✅ Approuver
          </Button>
        </div>
      ))}
    </div>
  );
}
